export const days = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];
